<template>
 

<div>
  <v-btn
                color="accent-2"
                class="blue--text"
                @click="dialog = true"
              >
               <v-icon>mdi-currency-usd</v-icon>Transactions
              </v-btn>
  <v-dialog v-model="dialog" 
  scrollable
  @keydown.esc="dialog = false"
  >
    <v-card>
      <v-card-title>
        <v-text-field
                       v-model="filter"
                       append-icon="mdi-filter"
                       label="Type to filter"
                       
                     ></v-text-field>
      </v-card-title>
      <v-card-text style="min-height: 69vh">

        <v-data-table  v-if="allTransactionsByDate"
        :search="filter"
        :items-per-page="50"
        @current-items="getFiltered"
                        :headers="headers" 
                        :items="allTransactionsByDate" item-key="id">
                        <template v-slot:item.price="{ item }">
                    <span >${{item.price}} </span>
                  </template>
                        <template slot="body.append">
                            <tr class="pink--text">
                                <th class="title">Total</th>
                                <th class="title">${{ total }}</th>
                            </tr>
                        </template>
                    </v-data-table>
<p>Press  <v-icon>mdi-keyboard-esc</v-icon> to close this card</p>
      </v-card-text> 
<v-card-actions>
  <v-spacer></v-spacer>
  <v-btn @click="dialog = false">Close</v-btn>
</v-card-actions>
    </v-card>
  </v-dialog>
</div>
    
</template>

<script>
    import { mapState } from 'vuex'
  

    export default {
      
        data() {


            return {

              dialog : false,
              filter : '',
              total : 0
             
            }
        },


        computed: {

            allTransactionsByDate(){

            return this.$store.getters.allTransactionsByDate

          },

          filtered() {

            return this.getFiltered()
            
          },

            headers() {

              return this.getHeaders(this.allTransactionsByDate)
            },            


        },


        methods: {

          getFiltered(e){
            this.total = this.sum(e, 'price')
           }
        }
    }
</script>